import React, { useContext, useState } from "react";
import { NavLink, useHistory } from "react-router-dom";
import Cookies from "js-cookie";
import Menu from "@material-ui/core/Menu";
import MenuItem from "@material-ui/core/MenuItem";
import { AppContext } from "../../../../App";
import { useTranslation } from "react-i18next";
import getUserRoleName from "../../../../utils/userRoleName";
import { THEME_COLOR } from "../../../../utils/consts";
import LanguageSelect from "../language/LanguageSelect";
import ExchangerBar from "../../exchanger/ExchangerBar";

import logo from "../../../../assets/images/logo.svg";
import {
  StyledDropdownBtn,
  StyledDropdownItem,
  StyledSidebarBtn,
  StyledToolbarButton,
  StyledToolbarButtonWrapper,
  StyledToolbarContent,
  StyledToolbarUserInfo,
  StyledToolbarWrapper, StyledUserDescription,
  StyledUserName,
  StyledUserPhoto, StyledUserRole
} from "./styledToolbar";

const Toolbar = ({ sidebar, handleDrawerOpen, setAuthentication }) => {

  const { user, theme } = useContext(AppContext);
  const { t } = useTranslation("navigation");
  const isLightTheme = theme.themeName === THEME_COLOR.LIGHT;
  const themeIcon = isLightTheme ? "icon-light-dark-theme" : "icon-light-light-theme";
  const themeLabel = isLightTheme ? t("switchToDarkTheme") : t("switchToLightTheme");
  //Example
  const client = {
    img: null
  };

  const history = useHistory();
  const [anchorEl, setAnchorEl] = useState(null);

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };
  const logout = () => {
    Cookies.remove("token");
    setAuthentication(false);
    history.push("/");
  };

  return (
    <StyledToolbarWrapper open={sidebar}>
      <StyledSidebarBtn
        onClick={handleDrawerOpen}
        open={sidebar}
      >
        <img
          src={logo}
          alt="logo"
          className="toolbar-logo__drawer-icon"
        />
      </StyledSidebarBtn>
      <StyledToolbarContent open={sidebar}>
        {/*<StyledSearchInput className="search-field toolbar-search">*/}
        {/*<TextField*/}
        {/*  className="search-field__text toolbar-search__text"*/}
        {/*  id="toolbarSearch"*/}
        {/*  label={<span className="icon-light-search search-field__icon">Поиск...</span>}*/}
        {/*  variant="filled"/>*/}
        {/*</StyledSearchInput>*/}
        <LanguageSelect />
        <StyledToolbarButtonWrapper>
          <StyledToolbarButton
            title={themeLabel}
            onClick={theme.toggleTheme}
          >
            <span className={themeIcon} />
          </StyledToolbarButton>
          <ExchangerBar />
          <StyledToolbarButton
            as="a"
            href="https://t.me/+ijgQuonZwwYyZTM6"
            target="_blank"
            title={t("telegramChannelForCustomers")}
          >
            <span className="icon-social-telegram-line" />
          </StyledToolbarButton>
        </StyledToolbarButtonWrapper>
        <StyledToolbarUserInfo>
          <StyledUserPhoto>
            {client.img ? <img
              src={`/uploads/${client.img}`}
              className="user-photo"
              alt="user photo"
            /> : <span>{user.email.charAt(0)}</span>}
          </StyledUserPhoto>
          <StyledUserDescription>
            <StyledUserName>
              {user.email}
            </StyledUserName>
            <StyledUserRole>
              {getUserRoleName(user.roles)}
            </StyledUserRole>
          </StyledUserDescription>
          <StyledDropdownBtn onClick={handleClick}>
            <span className="icon-light-chevron-down" />
          </StyledDropdownBtn>
          <Menu
            id="simple-menu"
            anchorEl={anchorEl}
            keepMounted
            open={Boolean(anchorEl)}
            onClose={handleClose}
            className="toolbar-dropdown"
          >
            <MenuItem
              onClick={() => {
                handleClose();
                theme.toggleTheme();
              }}
              className="toolbar-dropdown__item toolbar-dropdown__item_theme"
            >
              <StyledDropdownItem>
                <span className={themeIcon} />
                <p>
                  {themeLabel}
                </p>
              </StyledDropdownItem>
            </MenuItem>
            {/*<MenuItem
              onClick={handleClose}
              className="toolbar-dropdown__item"
            >
              <StyledDropdownItem
                as={NavLink}
                to="/"
              >
                <span className="icon-light-help" />
                <p>
                  {t("help")}
                </p>
              </StyledDropdownItem>
            </MenuItem>*/}
            <MenuItem onClick={handleClose} className="toolbar-dropdown__item">
              <StyledDropdownItem as="a" href="https://t.me/+ijgQuonZwwYyZTM6" target="_blank">
                <span className="icon-social-telegram-line" />
                <p>
                  {t("telegram")}
                </p>
              </StyledDropdownItem>
            </MenuItem>
            <MenuItem
              onClick={handleClose}
              className="toolbar-dropdown__item"
            >
              <StyledDropdownItem
                as={NavLink}
                to="/account"
              >
                <span className="icon-light-settings" />
                <p>
                  {t("accountSettings")}
                </p>
              </StyledDropdownItem>
            </MenuItem>
            <MenuItem
              onClick={() => {
                handleClose();
                logout();
              }}
              className="toolbar-dropdown__item"
            >
              <StyledDropdownItem>
                <span className="icon-light-exit" />
                <p>
                  {t("logout")}
                </p>
              </StyledDropdownItem>
            </MenuItem>
          </Menu>
        </StyledToolbarUserInfo>

      </StyledToolbarContent>
    </StyledToolbarWrapper>

  );
};

export default Toolbar;